import { install } from "vue3-recaptcha-v2";

export default function (app, env) {
    const RECAPTCHA_KEY = env.VITE_RECAPTCHA_KEY;
    if (RECAPTCHA_KEY) {
        app.use(install, {
            sitekey: RECAPTCHA_KEY,
            cnDomains: false
        });
    }
}
